import { SET_PROVIDERS } from '../actions/providers';

export const providersReducer = (state, action) => {
  const { type, payload } = action;

  switch (type) {
    case SET_PROVIDERS:
      return {
        ...state,
        providers: payload,
      };
    default:
      return undefined;
  }
};
